import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import { P } from 'components/fontSystem';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import bfbTheme from 'styles/b4b-theme';
import getPasswordChecks from 'utils/getPasswordChecks';

const PasswordChecklist = ({ password = '', userAttributes = {}, t }) => {
  const {
    atLeast10Chars,
    atLeast1Number,
    atLeast1SpecialChar,
    passwordIsNotSimilar,
    passwordIsUncommon,
  } = getPasswordChecks(password, userAttributes);

  return (
    <Flex vertical gap={5}>
      <ChecklistItemFlex $isValid={atLeast10Chars} gap={5} align="center">
        {atLeast10Chars ? (
          <CheckOutlined data-testid="atLeast10Chars-check-valid" />
        ) : (
          <CloseOutlined data-testid="atLeast10Chars-check-invalid" />
        )}
        <P $mb0>{t('At least 10 characters')}</P>
      </ChecklistItemFlex>
      <ChecklistItemFlex $isValid={atLeast1Number} gap={5} align="center">
        {atLeast1Number ? (
          <CheckOutlined data-testid="atLeast1Number-check-valid" />
        ) : (
          <CloseOutlined data-testid="atLeast1Number-check-invalid" />
        )}
        <P $mb0>{t('At least 1 number')}</P>
      </ChecklistItemFlex>
      <ChecklistItemFlex $isValid={atLeast1SpecialChar} gap={5} align="center">
        {atLeast1SpecialChar ? (
          <CheckOutlined data-testid="atLeast1SpecialChar-check-valid" />
        ) : (
          <CloseOutlined data-testid="atLeast1SpecialChar-check-invalid" />
        )}
        <P $mb0>{t('At least 1 special character')}</P>
      </ChecklistItemFlex>
      <ChecklistItemFlex $isValid={passwordIsNotSimilar} gap={5} align="center">
        {passwordIsNotSimilar ? (
          <CheckOutlined data-testid="passwordIsNotSimilar-check-valid" />
        ) : (
          <CloseOutlined data-testid="passwordIsNotSimilar-check-invalid" />
        )}
        <P $mb0>{t('Different from your name or email')}</P>
      </ChecklistItemFlex>
      <ChecklistItemFlex $isValid={passwordIsUncommon} gap={5} align="center">
        {passwordIsUncommon ? (
          <CheckOutlined data-testid="passwordIsUncommon-check-valid" />
        ) : (
          <CloseOutlined data-testid="passwordIsUncommon-check-invalid" />
        )}
        <P $mb0>{t('Not a commonly used password')}</P>
      </ChecklistItemFlex>
    </Flex>
  );
};

PasswordChecklist.propTypes = {
  password: PropTypes.string,
  userAttributes: PropTypes.instanceOf(Object),
  t: PropTypes.func.isRequired,
};

const ChecklistItemFlex = styled(Flex)`
  color: ${props => (props.$isValid ? bfbTheme.memberGreen : bfbTheme.error)};
  .anticon {
    font-size: 15px;
  }
`;

export default PasswordChecklist;
